import React, {
    useContext,
    useState
  } from "react";
  import './accessControl.styles.scss'
  
  import { MouseContext } from "../../context/mouse-context"
  
  const AccessControl = ({toggleCanAccess}) => {
    const {cursorChangeHandler} = useContext(MouseContext);
    const [errorDisplay, toggleErrorDisplay] = useState(false);
    const [passwordInput, setPasswordInput] = useState('')

    const passwordFieldHandler =(e)=>{
        if (e.key == 'Enter'){
            submitHandler()
        }
    }

    const submitHandler = ()=>{
        if(passwordInput == 'banana'){
            localStorage.setItem('access', true)
            toggleCanAccess(true)
        }else{
            setPasswordInput('')
            toggleErrorDisplay(true)
        }
    }
  
    return(
      <div className='access-wrapper'>
            <div className="access-input-field-wrapper">
                <div className={`error-idle ${errorDisplay ? 'error-active':''}`}>Sorry! Wrong password.</div>
                <input type="text" placeholder='Password' name="password-field" className="access-input-field" onChange={(e)=>{setPasswordInput(e.target.value)}} onKeyPress={(e)=>{passwordFieldHandler(e)}} />
                <div className="password-submit" onClick={()=>{submitHandler()}}>
                    Submit
                </div>
            </div>
      </div>
  
    )
  }
  
  export default AccessControl;